import { APP_NAME_SHORT } from '@/utils/appUtils.ts';
import type { Localization } from '../../common/Localization';
import { platformVersion } from './index';
import { createLocaleForAnalytics } from '../../utils/formatting';

export const PLATFORM_DATA_PRODUCT_VARIANT = {
  FLEXIBLE: 'flexible',
  FLASH_SALES: 'flash_sales',
};

export const createCommonPageParams = (localization: Localization) => {
  const { coreBrand, locale, isWhiteLabel, categoryLevelCode, whiteLabelName } = localization;
  const analyticsLocale = createLocaleForAnalytics({ locale });
  const whitelabelName = isWhiteLabel ? { whitelabelName: whiteLabelName.toLowerCase() } : {};

  return {
    brand: coreBrand,
    locale: analyticsLocale,
    platformName: APP_NAME_SHORT,
    platformVersion,
    categoryLevelCode,
    ...whitelabelName,
  };
};
